<script>
import PrivacyPolicySection from '../components/section/privacypolicies/PrivacyPolicySeciton'
export default {
  name: 'PrivacyPolicies',
  components: { PrivacyPolicySection },
  metaInfo () {
    return {
      title: this.$t('privacy_policy.page_title'),
      titleTemplate: null,
      htmlAttrs: {
        lang: this.$i18n.locale, amp: true
      },
      meta: [
        {
          name: 'description',
          content: 'This Privacy Policy outlines the types of personal information collected, used, and shared by Idriss OULAHBIB through their portfolio website (idrissoulahbib.com). By using this website, you agree to the terms and practices described in this policy.'
        }
      ]
    }
  }
}
</script>

<template>
  <main class="container mx-auto">
    <privacy-policy-section />
  </main>
</template>

<style scoped>

</style>
